import { Box, Flex } from '@shared/components';
import type { PropsWithChildren } from '@shared/utils';

interface QuestionLayoutProps extends PropsWithChildren {
  sideContent: React.ReactNode;
}

export default function QuestionLayout(props: Readonly<QuestionLayoutProps>) {
  const { children, sideContent } = props;
  return (
    <Flex sx={(theme) => ({ gap: theme.spacing(6), p: theme.spacing(6) })}>
      <Box sx={{ flexBasis: 360 }}>{sideContent}</Box>
      <Flex sx={{ flex: 1 }}>{children}</Flex>
    </Flex>
  );
}
